import { withRouter } from "react-router";
import Background from "../components/Background";
import Button from "../components/Button";
import NavTopBar from "../components/NavTopBar";
import PlainContainer from "../components/PlainContainer";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import OverTableButtons from "../components/OverTableButtons";

const PublisherFormView = ({ history }) => {
  return (
    <>
      <NavTopBar />
      <Background height="45vh" />
      <OverTableButtons
        widthInVw={95}
        heightInVh={4.1}
        customStyles={{ top: "15.5vh" }}
      >
        <Button
          text={
            <div style={{ display: "flex" }}>
              <FontAwesomeIcon
                icon={faChevronLeft}
                style={{
                  alignSelf: "center",
                  marginRight: "6px",
                }}
              />
              Powrót
            </div>
          }
          onClick={() => history.push(`/publishers`)}
          styleOptions={{
            height: "100%",
          }}
        />
      </OverTableButtons>
      <PlainContainer
        widthInVw={95}
        heightInVh={78}
        customStyles={{
          top: "19vh",
          position: "absolute",
          left: "50%",
          transform: "translateX(-50%)",
          paddingBottom: "0px",
        }}
      >
        {/* <RegisterPublisher /> */}
      </PlainContainer>
    </>
  );
};

export default withRouter(PublisherFormView);
